<template>
    <v-app id="telsasoft-application" :class="{'thin-scrollbar': thinScrollbar}">        
        <express-renderer v-if="$store.state.expressMode"></express-renderer>
        <template v-else>

        <v-navigation-drawer v-model="drawer" app clipped v-if="$route.name != 'login'">
            <v-list dense class="mb-6">

                <draggable v-model="locations" v-bind="dragOptions" @end="navMenuChanged">
                    <div v-for="location in locations" :key="location.text">

                        <template v-if="!navigationPermissions.hasOwnProperty(location.name) || navigationPermissions[location.name]">
                            <v-list-item :key="location.text" v-if="!location.items" @click="navigate(location.name)">
                                <v-list-item-icon>
                                    <v-icon :style="{color: ($route.name == location.name) ? '#c42111' : '#ffffff'}">{{ location.icon }}</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title :style="{color: ($route.name == location.name) ? '#c42111' : '#ffffff'}">{{ location.text }}</v-list-item-title>
                            </v-list-item>

                            <v-list-group :key="location.text" :prepend-icon="location.icon" :value="false" v-if="location.items" color="#ffffff">
                                <template v-slot:activator>
                                    <v-list-item-title>{{ location.text }}</v-list-item-title>
                                </template>
                                <v-list-item v-for="(item, i) in location.items" :key="i" link @click="navigate(item.name)">
                                    <v-list-item-icon class="ml-4">
                                    <v-icon :style="{color: ($route.name == item.name) ? '#c42111' : '#ffffff'}">{{ item.icon }}</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-title :style="{color: ($route.name == item.name) ? '#c42111' : '#ffffff'}">{{ item.text }}</v-list-item-title>
                                </v-list-item>
                            </v-list-group>
                        </template>

                        <template v-else>
                            <v-list-item :key="location.text" @click="" disabled>
                                <v-list-item-icon><v-icon color="rgba(255,255,255,0.5)">mdi-lock</v-icon></v-list-item-icon>
                                <v-list-item-title>{{ location.text }}</v-list-item-title>
                            </v-list-item>
                        </template>

                    </div>
                </draggable>

            </v-list>

            <div class="about-info-container" @click="$store.commit('setTelsasoftAbout', {show: true})" v-if="$store.state.user">
                <span><v-icon style="marginTop: -2px;">mdi-information</v-icon> About Telsasoft</span>
            </div>
            <!-- <span class="host-text" v-if="$route.name != 'login' && $store.state.user && $store.state.user.telsaserver_host" @click="$socket.emit('info')">{{`${$store.state.user.telsaserver_host}`}}</span> --> 
        </v-navigation-drawer>

        <inactivity-mode :checkIntervalSec="5" v-if="applicationReady" />

        <!-- Messaging Drawer -->
        <div id="messaging-drawer-overlay" :style="{display: $store.state.messagingDrawerOpen ? 'inherit' : 'none' }" />
        <v-navigation-drawer v-model="$store.state.messagingDrawerOpen" id="messaging-drawer" fixed right width="50%" stateless>
            <messaging v-if="$store.state.messagingDrawerOpen" @close="$store.commit('setMessagingDrawerOpen', false)"></messaging>
        </v-navigation-drawer>

        <!-- Screenshot Drawer -->
        <div id="screenshots-drawer-overlay" :style="{display: $store.state.screenshotsDrawerOpen ? 'inherit' : 'none' }" />
        <v-navigation-drawer v-model="$store.state.screenshotsDrawerOpen" id="screenshots-drawer" fixed right width="50%" stateless>
            <screenshots v-if="$store.state.screenshotsDrawerOpen" @close="$store.commit('setScreenshotsDrawerOpen', false)"></screenshots>
        </v-navigation-drawer>

        <v-app-bar app clipped-left color="#c42111" dense>
            <v-app-bar-nav-icon @click.stop="drawer = !drawer" v-if="$route.name != 'login'"></v-app-bar-nav-icon>

            
            <v-icon class="development" v-if="development">mdi-code-greater-than</v-icon>
            <!-- <img id="ts-logo" class="ml-2" src="img/tsLogo.png" /> -->
            <img id="ts-logo" class="ml-2" src="@/assets/tsLogo.png" v-if="!development" />

            <v-toolbar-title id="application-title" class="ml-2 mr-12 align-center">
                <span class="title">TELSASOFT</span>
            </v-toolbar-title>

            <v-spacer></v-spacer>

            <!-- APP BAR ICONS -->
            <!-- <v-btn icon v-if="$route.name == 'dashboard' && $store.state.batchConfig && $store.state.batchConfig.tableau" @click="$store.commit('displayTableauCreds', !$store.state.batchConfig.tableau.displayCreds)">
                <v-icon>mdi-key-variant</v-icon>
            </v-btn> -->

            <v-icon size="16" v-if="$store.state.alarmActivity">fas fa-sync-alt fa-spin</v-icon>

            <div id="app-bar-icons">

                <v-menu offset-y nudge-left="206" nudge-top="8" z-index="1001" :content-class="'no-box'" v-if="$store.state.user && navigationPermissions.reports" :close-on-content-click="false" v-model="showBackgroundReports">
                    <template #activator="{ on: onMenu }">
                        <v-tooltip bottom v-on="onMenu" color="rgba(97, 97, 97, 1.0)">
                            <template #activator="{ on: onTooltip }">
                                <v-btn icon title="Running Reports" v-on="{ ...onMenu, ...onTooltip }">
                                    <v-icon v-if="!$store.getters.backgroundReportCounts.runningCount">mdi-chart-bar</v-icon>
                                    <v-icon v-if="$store.getters.backgroundReportCounts.runningCount">fas fa-circle-notch fa-spin</v-icon>
                                    <span class="background-report-running-count" v-if="$store.getters.backgroundReportCounts.runningCount">{{$store.getters.backgroundReportCounts.runningCount}}</span>
                                    <span class="background-report-completed-count" v-if="$store.getters.backgroundReportCounts.completedCount">{{$store.getters.backgroundReportCounts.completedCount}}</span>
                                </v-btn>
                            </template>
                            <span>Background Reports</span>
                        </v-tooltip>
                    </template>
                    <background-reports-summary @close="showBackgroundReports = false"></background-reports-summary>
                </v-menu>

                <v-menu v-model="alarmTrayOpen" offset-y nudge-left="220" nudge-top="8" z-index="1001" :content-class="'no-box'" v-if="$store.state.user && navigationPermissions.alarms">
                    <template #activator="{ on: onMenu }">
                        <v-tooltip bottom v-on="onMenu" color="rgba(97, 97, 97, 1.0)">
                            <template #activator="{ on: onTooltip }">
                                <v-btn icon title="Alarm Summary" v-on="{ ...onMenu, ...onTooltip }">
                                    <v-icon v-if="gettingInitialAlarmsList">fas fa-circle-notch fa-spin</v-icon>
                                    <v-icon :class="{'warn-blink': (telsasoftUnackAlarmsExist && !alarmTrayOpen)}" v-if="!gettingInitialAlarmsList">mdi-bell-ring</v-icon>
                                </v-btn>
                            </template>
                            <span>Alarm Summary</span>
                        </v-tooltip>
                    </template>
                    <alarm-count-summary :gettingInitialAlarmsList="gettingInitialAlarmsList"></alarm-count-summary>
                </v-menu>

                <v-menu v-model="issueTrayOpen" offset-y nudge-left="180" nudge-top="8" z-index="1001" :content-class="'no-box'" v-if="$store.state.user && navigationPermissions.issues">
                    <template #activator="{ on: onMenu }">
                        <v-tooltip bottom v-on="onMenu" color="rgba(97, 97, 97, 1.0)">
                            <template #activator="{ on: onTooltip }">
                                <v-btn icon title="Issues Summary" v-on="{ ...onMenu, ...onTooltip }">
                                    <v-icon v-if="gettingInitialIssuesList">fas fa-circle-notch fa-spin</v-icon>
                                    <v-icon v-if="!gettingInitialIssuesList">mdi-sticker-alert</v-icon>
                                </v-btn>
                            </template>
                            <span>Issues Summary</span>
                        </v-tooltip>
                    </template>
                    <issue-count-summary :gettingInitialIssuesList="gettingInitialIssuesList" />
                </v-menu>

                <v-menu v-model="pagingRatesTrayOpen" offset-y nudge-left="336" nudge-top="8" z-index="1001" :content-class="'no-box'" v-if="$store.state.user && navigationPermissions.alarms">
                    <template #activator="{ on: onMenu }">
                        <v-tooltip bottom v-on="onMenu" color="rgba(97, 97, 97, 1.0)">
                            <template #activator="{ on: onTooltip }">
                                <v-btn icon title="Paging Rates" v-on="{ ...onMenu, ...onTooltip }">
                                    <v-icon :class="{'warn-blink': false}">mdi-phone-ring</v-icon>
                                </v-btn>
                            </template>
                            <span>Paging Rates</span>
                        </v-tooltip>
                    </template>
                    <paging-rates :changes="pageCounterChanges" />
                </v-menu>

                <v-menu offset-y nudge-left="155" nudge-top="8" z-index="1001" :content-class="'no-box'" v-if="$store.state.user">
                    <template #activator="{ on: onMenu }">
                        <v-tooltip bottom v-on="onMenu" color="rgba(97, 97, 97, 1.0)">
                            <template #activator="{ on: onTooltip }">
                                <v-btn icon title="Connection Info" v-on="{ ...onMenu, ...onTooltip }">
                                    <v-icon v-if="$store.getters.connectionStatusObj.connectionStatus">mdi-wifi</v-icon>
                                    <v-icon v-if="!$store.getters.connectionStatusObj.connectionStatus">mdi-wifi-off</v-icon>
                                </v-btn>
                            </template>
                            <span>Connection Info</span>
                        </v-tooltip>
                    </template>
                    <connection-info></connection-info>
                </v-menu>

                
                <v-tooltip bottom color="rgba(97, 97, 97, 1.0)" v-if="$store.state.user && !($store.state.webRtc.show && $store.state.minimizeWebRtc)">
                    <template v-slot:activator="{ on }">
                        <v-btn icon @click="$store.commit('setMessagingDrawerOpen', !$store.state.messagingDrawerOpen)" title="Messages" v-on="on">
                            <v-icon>mdi-wechat</v-icon>
                            <div class="new-message-count" v-if="unreadChatMessages">
                                <span v-text="unreadChatMessages"></span>
                            </div>
                        </v-btn>
                    </template>
                    <span>Messages</span>
                </v-tooltip>
                <v-btn icon @click="$store.commit('setMinimizeWebRtc', false)" v-if="$store.state.user && $store.state.webRtc.show && $store.state.minimizeWebRtc">
                    <v-icon class="pulse">mdi-phone-in-talk</v-icon>
                </v-btn>


                <v-tooltip bottom color="rgba(97, 97, 97, 1.0)" v-if="$store.state.user && !takingScreenshot">
                    <template v-slot:activator="{ on }">
                        <v-btn icon @click="$store.commit('setScreenshotsDrawerOpen', !$store.state.screenshotsDrawerOpen)" title="Screenshots" v-on="on" v-long-press="500" @long-press-start="takeScreenshot">
                            <v-icon>mdi-monitor-screenshot</v-icon>
                            <div class="screenshots-count" v-if="$store.state.screenshots.length">
                                <span v-text="$store.state.screenshots.length"></span>
                            </div>
                        </v-btn>
                    </template>
                    <span>Screenshots</span>
                </v-tooltip>
                <v-btn icon v-if="takingScreenshot">
                    <v-icon>fas fa-spin fa-sync</v-icon>
                </v-btn>

            </div>

            <!-- <v-row align="right" style="max-width: 300px"> -->
            <v-row style="max-width: 300px">
                <div class="username-row" v-if="$store.state.user">
                    <v-menu offset-y>
                        <template v-slot:activator="{ on }">
                        <div class="username-container" v-on="on">
                            <span v-text="$store.state.user.user_username" class="username-text" />
                            <v-icon class="mx-2" v-if="!$store.state.userImage">fa fa-user-circle</v-icon>
                            <img class="mx-2" id="user-img" v-if="$store.state.userImage" :src="$store.state.userImage" />
                        </div>
                        </template>
                        <user-info @logout="logout"></user-info>
                    </v-menu>
                </div>
            </v-row>

        </v-app-bar>

        <alarm-snackbar v-if="$store.state.user" />
        <connection-snackbar v-if="$store.state.user" />
        <!-- <connection-snackbar v-if="$store.state.user && $store.state.connectionSnackbar.active" /> -->

        <v-main>
            <v-container class="fill-height" fluid style="padding: 3px;">
                <!-- LOADING -->
                <div id="loading-overlay">
                    <v-icon id="loading-icon">fa fad-spinner-third fa-spin</v-icon>
                    <!-- <div id="loading-icon" class="loading-icon-outer" style="display: table;">
                    <div id="loading-icon-container" class="loading-icon">
                        <div id="loading-icon-inner-1" class="loading-icon-inner loading-icon"></div>
                        <div id="loading-icon-inner-2" class="loading-icon-inner loading-icon"></div>
                        <div id="loading-icon-inner-3" class="loading-icon-inner loading-icon"></div>
                        <div id="loading-icon-inner-4" class="loading-icon-inner loading-icon"></div>
                        <div id="loading-icon-inner-5" class="loading-icon-inner loading-icon"></div>
                    </div>
                    </div> -->
                </div>

                <!-- AUTHENTICATING -->
                <authenticating v-if="$store.state.authenticating" />

                <router-view id="application-router-view-container" @applicationResources="setApplicationResources" v-if="$store.state.user || $route.name == 'login'"></router-view>
            </v-container>
        </v-main>

        <!-- HELP WINDOW -->
        <wiki-dialog v-model="$store.state.wikiHelp.show" v-if="$store.state.wikiHelp.show" />

        <!-- ERROR DIALOG -->
        <error-dialog v-model="showErrorDialog" :title="dialogTitle" :message="dialogMessage" />

        <!-- CONFIRM DIALOG -->
        <confirm v-model="$store.state.confirmModal.show" />

        <!-- UNVERIFIED DIALOG -->
        <unverified-dialog v-model="showUnverifiedDialog" :smsUnverified="smsUnverified" :emailUnverified="emailUnverified" v-if="showUnverifiedDialog" />

        <!-- NEW FEATURE DIALOG -->
        <new-feature-dialog v-model="showNewFeatureDialog" v-if="showNewFeatureDialog" />

        <!-- ABOUT DIALOG -->
        <telsasoft-about v-model="$store.state.telsasoftAbout.show" @new-features="showNewFeatureDialog = true" />

        <!-- BROADCAST DIALOG -->
        <broadcast-dialog v-model="$store.state.broadcastMessage.show" />

        <!-- PAGING CLIENT-NOTIFY DIALOG -->
        <paging-client-dialog v-model="$store.state.pagingClientMessage.show" />

        <!-- PUSH NOTIFICAIOTN SUBSCRIPTION PERMISSIONS DIALOG -->
        <push-notification-permission-dialog v-model="showPushNotificationPermissionDialog" v-if="showPushNotificationPermissionDialog" :onAccept="pushNotificationPermissionAcceptFunc" />

        <!-- AUDIO PLAYER ELEMENT -->
        <audio :src="$store.state.audioPlayData" autoplay @ended="$store.commit('advanceAudioQueue')"></audio>

        <!-- WEB RTC -->
        <web-rtc v-model="$store.state.webRtc.show" v-if="$store.state.webRtc.show" />
        <!-- <web-rtc v-model="$store.state.webRtc.show" /> -->
        <!-- <web-rtc /> -->

        <!-- AI ANALYZER BOTTOM SHEET -->
        <v-bottom-sheet v-model="$store.state.showAIAnalyzer" v-if="$store.state.batchConfig && $store.state.batchConfig.webapp_openai && $store.state.aiAnalyzerGridAPI">
            <ai-analyzer :context="$store.state.aiAnalyzerContext" :gridApi="$store.state.aiAnalyzerGridAPI" @close="$store.commit('setShowAIAnalyzer', false);" />
        </v-bottom-sheet>

        </template>
    </v-app>
</template>


<script>
import Vue from 'vue';
import VueSocketIO from 'vue-socket.io';
import VueResource from 'vue-resource';
Vue.use(VueResource);

import Highcharts from 'highcharts';
import HighchartsVue from 'highcharts-vue';
Vue.use(HighchartsVue)
import exporting from 'highcharts/modules/exporting';
exporting(Highcharts);
import html2canvas from 'html2canvas';
import LongPress from 'vue-directive-long-press'
Vue.directive('long-press', LongPress)
import draggable from "vuedraggable";

import './helpers';
import ExpressRenderer from '@/ExpressRenderer';
import ErrorDialog from '@/views/ErrorDialog';
import Confirm from '@/views/Confirm';
import BroadcastDialog from '@/views/BroadcastDialog';
import TelsasoftAbout from '@/components/TelsasoftAbout';
import PagingClientDialog from '@/views/PagingClientDialog';
import WikiDialog from '@/views/WikiDialog';
import Authenticating from '@/components/Authenticating';
import UserInfo from '@/components/UserInfo';
import BackgroundReportsSummary from '@/components/BackgroundReportsSummary';
import AlarmCountSummary from '@/components/AlarmCountSummary';
import IssueCountSummary from '@/components/IssueCountSummary';
import PagingRates from '@/components/PagingRates';
import ConnectionInfo from '@/components/ConnectionInfo';
import AlarmSnackbar from '@/components/AlarmSnackbar';
import ConnectionSnackbar from '@/components/ConnectionSnackbar';
import Messaging from '@/components/Messaging';
import Screenshots from '@/components/Screenshots';
import WebRtc from '@/components/WebRtc';
import UnverifiedDialog from '@/components/UnverifiedDialog';
import NewFeatureDialog from '@/components/NewFeatureDialog';
import PushNotificationPermissionDialog from '@/components/PushNotificationPermissionDialog';
import AIAnalyzer from '@/components/AIAnalyzer';
import InactivityMode from '@/components/InactivityMode';

if(process.env.NODE_ENV == 'production') {
    //TELSA.apiHost = 'api/';
    TELSA.apiHost = `${window.location.origin}/api/`;
    TELSA.staticHost = `${window.location.origin}/`;
}
else if(process.env.NODE_ENV == 'development') {
    TELSA.apiHost = `https://${window.location.hostname}:5000/api/`;
    TELSA.staticHost = `https://${window.location.hostname}:5000/`;
}

export default {
    name: 'App',
    components: {
        ExpressRenderer,
        ErrorDialog,
        Authenticating,
        UserInfo,
        BackgroundReportsSummary,
        AlarmCountSummary,
        IssueCountSummary,
        PagingRates,
        ConnectionInfo,
        Confirm,
        BroadcastDialog,
        TelsasoftAbout,
        PagingClientDialog,
        WikiDialog,
        AlarmSnackbar,
        ConnectionSnackbar,
        Messaging,
        Screenshots,
        WebRtc,
        draggable,
        UnverifiedDialog,
        NewFeatureDialog,
        PushNotificationPermissionDialog,
        'ai-analyzer': AIAnalyzer,
        InactivityMode
    },
    props: {
        source: String,
    },
    data: () => ({
        development: process.env.NODE_ENV == 'development',
        drawer: null,
        locations: [],
        allLocations: [
            { icon: 'mdi-home', text: 'Home', name: 'home' },
            { icon: 'mdi-monitor-dashboard', text: 'Dashboards', name: 'dashboard_items', items: [
                    { icon: 'mdi-cloud', text: 'Cloud', name: 'dashboard' },
                    { icon: 'mdi-view-dashboard-variant', text: 'Local', name: 'tsdashboard' },
                ]
            },
            { icon: 'mdi-chart-bar', text: 'Reports', name: 'reports' },
            { icon: 'mdi-history', text: 'Report History', name: 'reporthistory' },
            { icon: 'mdi-timetable', text: 'Special Reports', name: 'specialreports' },
            { icon: 'mdi-card-account-details', text: 'User Thresholds', name: 'userthresholds' },
            { icon: 'mdi-clipboard-text', text: 'Threshold Profiles', name: 'thresholdprofiles' },
            { icon: 'mdi-router-wireless', text: 'Devices', name: 'device_items', items: [
                    { icon: 'mdi-access-point-network', text: 'Ping Targets', name: 'pingtargets' },
                    { icon: 'mdi-email-edit', text: 'SMTP', name: 'smtp' },
                    { icon: 'mdi-server', text: 'SNMP', name: 'snmp' },
                    { icon: 'mdi-network', text: 'Network Elements', name: 'networkdevices' },
                    { icon: 'mdi-lan-pending', text: 'Network Discovery', name: 'networkdiscovery' },
                ]
            },
            { icon: 'mdi-radioactive', text: 'Sites', name: 'sites' },
            { icon: 'mdi-tag-multiple', text: 'Site Tags', name: 'sitegroups' },
            { icon: 'mdi-account-multiple', text: 'Users', name: 'users' },
            { icon: 'mdi-account-group', text: 'User Groups', name: 'usergroups' },
            { icon: 'mdi-book-open', text: 'Site Book', name: 'sitebook_items', items: [
                    { icon: 'mdi-cube', text: 'Common Objects', name: 'sitebookobjects' },
                    { icon: 'mdi-file-tree', text: 'Trees', name: 'sitebooktrees' },
                    { icon: 'mdi-book-open', text: 'Site Book', name: 'sitebook' },
                ]
            },
            { icon: 'mdi-bell-ring', text: 'Alarms', name: 'alarms' },
            { icon: 'mdi-google-maps', text: 'Geo Map', name: 'geomap' },
            { icon: 'mdi-bell-check', text: 'Alarm Modifications', name: 'alarmmodifications' },
            { icon: 'mdi-phone-ring-outline', text: 'Paging Rules', name: 'pagingrules' },
            { icon: 'mdi-bell-plus', text: 'Alarm Correlations', name: 'alarmcorrelations' },
            { icon: 'mdi-account-switch', text: 'Paging Substitutions', name: 'pagingsubstitutions' },
            { icon: 'mdi-sticker-alert', text: 'Issues', name: 'issues' },
            { icon: 'settings', text: 'Settings', name: 'settings' },
            { icon: 'mdi-account-voice', text: 'Support', name: 'support' }, 
            { icon: 'mdi-sitemap', text: 'Network Maps', name: 'networkmaps' }, 
            { icon: 'mdi-playlist-edit', text: 'Network Categories', name: 'networkcategories' },
            { icon: 'mdi-information-variant', text: 'Tutorials', name: 'tutorials' }, 
            //{ icon: 'mdi-lightning-bolt', text: 'Telsapp AI', name: 'telsappai' },
        ],
        showErrorDialog: false,
        dialogTitle: '',
        dialogMessage: '',
        pingFunction: null,
        pingCloudFunction: null,
        syncDynamicContentCacheFunction: null,
        takingScreenshot: false,
        showBackgroundReports: false,
        alarmTrayOpen: false,
        issueTrayOpen: false,
        pagingRatesTrayOpen: false,
        showUnverifiedDialog: false,
        showNewFeatureDialog: false,
        showPushNotificationPermissionDialog: false,
        pushNotificationPermissionAcceptFunc: null,
        smsUnverified: false,
        emailUnverified: false,
        gettingInitialAlarmsList: false,
        gettingInitialIssuesList: false,
        pageCounterUnsubscribeFunc: null,
        pageCounterChanges: 0,
        showAIAnalyzer: false,
        applicationReady: false
    }),

    computed: {
        kickoff: function() {
            return this.$store.state.kickoff;
        },

        audioPlayQueue: function() {
            return this.$store.state.audioPlayQueue;
        },

        unreadChatMessages: function() {
            let unread = 0;
            for(let contact of this.$store.state.contactMessages) {
                for(let message of contact.messages) {
                    if(message.unread) {
                        unread+=1;
                    }
                }
            }
            return unread;
        },

        thinScrollbar: function() {
            return (this.$store.state.batchConfig && this.$store.state.batchConfig.webapp_settings.preferences.thinScrollbar);
        },

        dragOptions() {
            return {
                animation: 200,
                group: "description",
                disabled: (this.$store.state.connectionInfo.client_device && (this.$store.state.connectionInfo.client_device.device_type != 'desktop' || navigator.maxTouchPoints > 1)),
                ghostClass: "ghost"
            };
        },

        navigationPermissions: function() {
            return this.$store.state.user ? this.$store.state.user.navigation_permissions : {};
        },

        telsasoftUnackAlarmsExist: function() {
            return this.$store.state.alarmsList.some(alarm => {
                return (alarm.alarm_office.toLowerCase().includes('telsasoft') && !alarm.alarm_ack_time);
            });
        },
    },

    methods: {
        navMenuChanged: function() {
            console.log('nav menu changed');
            let route = (TELSA.apiHost + "settings/navigationmenu");
            return this.$http.post(route, {args: {navigation_menu: JSON.stringify(this.locations)}}).then(response => {
                let result = response.body;
            });
        },

        navigate: function(name) {
            this.$router.push(name);
        },

        // Get application resources
        checkForJwtInLocalStorage: function() {
            if(localStorage.getItem('access_token') && !(TELSA.isTokenExpired(localStorage.getItem('access_token')))) {
                Vue.http.headers.common['Authorization'] = ('Bearer ' + localStorage.getItem('access_token'));
                // Verify account still in good standing and get the batch config and get current list of alarms.
                this.$store.commit('setAuthenticatingStatus', true);

                // TODO: Check if the token is pretty recent. Then we can pass a param along to tell the backend that tells
                // it that it doesn't need to do the device lookup(this takes along time). We will store/retrieve the device info
                // obj in local storage. 
                
                Vue.http.headers.common['X-Client-Version'] = this.$store.state.applicationVersion;
                let route = (TELSA.apiHost + "auth/verify");
                return this.$http.get(route).then(response => {
                    let applicationResources = response.body;
                    console.log('applicationResources: ', applicationResources);
                    this.setApplicationResources(applicationResources);

                    // If the route is emnpty and they have a "start page" defined then go there. If not, then go home. 
                    if((this.$route.name == null) && (applicationResources.batch_config.webapp_settings && applicationResources.batch_config.webapp_settings.preferences && applicationResources.batch_config.webapp_settings.preferences.startPage)) {
                        this.$router.push(applicationResources.batch_config.webapp_settings.preferences.startPage);
                    }
                    else {
                        if(this.$route.name == null) {
                            this.$router.push('home');
                        }
                    }

                    this.$store.commit('setAuthenticatingStatus', false);
                }, error => {
                    console.log('AUTH CHECK ERROR: ', error);
                    this.logout();
                });
            }
        },

        setApplicationResources: function(applicationResources) {
            Vue.http.headers.common['X-Client-Version'] = this.$store.state.applicationVersion;
            this.setNewAccessToken(applicationResources.jwt);
            
            // Check for iPad
            if(applicationResources.user.client_device.os_name && applicationResources.user.client_device.os_name.toLowerCase() == 'mac' && navigator.maxTouchPoints && navigator.maxTouchPoints > 0) {
                applicationResources.user.client_device.os_name = 'iPadOS';
                applicationResources.user.client_device.device_type = 'tablet';
                applicationResources.user.client_device.device_model = 'iPad';
                applicationResources.user.device_type = 'tablet';
            }
            this.$store.commit('setUser', applicationResources.user);
            this.$store.commit('setUserImage', applicationResources.user_image);
            this.$store.dispatch('setBatchConfig', applicationResources.batch_config);
            this.$store.dispatch('getUserImages');
            this.$store.dispatch('getAudioFileList');
            
            this.gettingInitialAlarmsList = true;
            this.$store.dispatch('getCurrentAlarms').then(r => {this.gettingInitialAlarmsList = false;});
            this.gettingInitialIssuesList = true;
            this.$store.dispatch('getCurrentIssues').then(r => {this.gettingInitialIssuesList = false;});
            
            this.$store.commit('setConnectionInfo', applicationResources.connection_info);
            this.createWebSocketConnection(applicationResources.connection_info.webSocketPort);
            this.setupContinuousServerPing();
            this.setupContinuousUpdateAvailableCheck();
            this.setupPeriodicBackgroundSync();
            this.setupPushNotifications();

            // Build the navigation menu items.
            this.locations = [];
            let allList = JSON.parse(JSON.stringify(this.allLocations));
            if(applicationResources.batch_config.navigation_menu) {
                let savedList = applicationResources.batch_config.navigation_menu;
                let idx = -1;
                for(let item of savedList) {
                    idx = allList.findIndex(l => {return l.icon == item.icon && l.text == item.text && l.name == item.name});
                    if(idx > -1) {
                        //this.locations.push(item);
                        this.locations.push(allList[idx]);
                        allList.splice(idx, 1);
                    }
                }
            }
            this.locations = this.locations.concat(allList);

            // Check if the user has an un-verified sms or email address and warn them about it.
            this.smsUnverified = (applicationResources.user.user_page_smpp && !(applicationResources.user.user_data && applicationResources.user.user_data.sms_verified));
            this.emailUnverified = (applicationResources.user.user_page_email && !(applicationResources.user.user_data && applicationResources.user.user_data.email_verified));
            if(this.smsUnverified || this.emailUnverified) {
                this.showUnverifiedDialog = true;
            }

            // Check if the user has already seen the New Features
            let majorVersion = parseInt(this.$store.state.applicationVersion.split('.')[0]);
            if(!(applicationResources.user.user_data && applicationResources.user.user_data.confirmed_feature_version && parseInt(applicationResources.user.user_data.confirmed_feature_version) >= majorVersion)) {
                this.showNewFeatureDialog = true;
            }
            this.applicationReady = true;
        },

        setNewAccessToken(jwt) {
            Vue.http.headers.common['Authorization'] = ('Bearer ' + jwt);
            localStorage.setItem('access_token', jwt);
            // This is because we need a way for the service worker to get the token for making api cals when the app is closed.
            TELSA.IDB.set('serviceWorkerAuthStore', 'access_token', jwt);
        },

        setupContinuousServerPing: function() {
            const self = this;
            this.pingFunction = setInterval(function() {
                let telsasoftCloudConnected = self.$store.state.connectionInfo.telsasoftCloudConnected;
                let route = (TELSA.apiHost + "auth/ping");
                self.$store.commit('setRunningPingCheckOn');
                return self.$http.get(route).then(response => {
                    let result = response.body;
                    self.$store.commit('setPingCheckResults', {webAppConnected: result.webAppConnected, telsaServerConnected: result.telsaServerConnected, telsasoftCloudConnected: telsasoftCloudConnected});
                }, error => {
                    self.$store.commit('setPingCheckResults', {webAppConnected: false, telsaServerConnected: false, telsasoftCloudConnected: telsasoftCloudConnected});
                });
            }, 9999999999);

            this.pingCloudFunction = setInterval(function() {
                let webAppConnected = self.$store.state.connectionInfo.webAppConnected;
                let telsaServerConnected = self.$store.state.connectionInfo.telsaServerConnected;
                let route = "https://page.telsasoft.com/pingtscloud";
                return self.$http.get(route).then(response => {
                    let result = response.body;
                    result = (result == "success");
                    self.$store.commit('setPingCheckResults', {webAppConnected: webAppConnected, telsaServerConnected: telsaServerConnected, telsasoftCloudConnected: result});
                }, error => {
                    self.$store.commit('setPingCheckResults', {webAppConnected: webAppConnected, telsaServerConnected: telsaServerConnected, telsasoftCloudConnected: false});
                });
            }, 600000); // 10min 
        },

        setupPeriodicBackgroundSync: function() {
            const self = this;
            // We want to setup this regardless if PBS is available because PBS will only run a few times a day at best.
            // Use a setInterval function to manually send a message to the SW to do the sync. This limits periodicSync to only active sessions.
            this.syncDynamicContentCacheFunction = setInterval(function() {
                self.$workbox.messageSW({type: 'SYNC_DYNAMIC_CONTENT_CACHE'});
            }, 900000) //15min

            let registerPeriodicBackgroundSync = function() {
                let fifteenMin = (15 * 60 * 1000);
                TELSA.swRegistration.periodicSync.register('sync-dynamic-content-cache', {minInterval: fifteenMin}).then(result => {
                    console.log('sync-dynamic-content-cache registered');
                }, error => {
                    console.log('Error registering sync-dynamic-content-cache: ', error);
                })
            }

            if(TELSA.swRegistration) {
                if(TELSA.swRegistration.periodicSync) {
                    navigator.permissions.query({name: 'periodic-background-sync'}).then(permissionStatus => {
                        if(permissionStatus.state == 'granted') {
                            // They have permissions, so go do the actual periodic background sync registration.
                            registerPeriodicBackgroundSync();
                        }
                        else {
                            // They dont have PBS permissions. This can only happen if the app isn't installed as a PWA.
                            // We still got the in-app setInterval function to do it tho so thats better than nothing.
                            console.warn('You must install the app as a PWA for periodic background sync to be enabled');
                        }
                    });
                }
                else {
                    console.warn('Your browser does not support periodic sync. Please use a chromium based browser.');
                }
            }
        },
        
        setupContinuousUpdateAvailableCheck: function() {
            const self = this;
            setInterval(function() {
                // Check if the users permissions have been changed and requires a refresh
                if(self.$store.state.refreshRequired) {
                    self.$store.commit('showConfirmModal', {
                        title: 'Permissions Changed',
                        message: `The System Administrator has changed your permissions. Please click <b>OK</b> to refresh the application.`,
                        type: 'warning',
                        hideCancel: false,
                        confirmAction: function(){location.reload();}
                    });
                }

                // Check if there is an updated ServiceWorker
                if(TELSA.swRegistration) {
                    TELSA.swRegistration.update().then(reg => {
                        if(reg && reg.waiting) {
                            self.$store.commit('showConfirmModal', {
                                title: 'Update Found',
                                message: `There is an application update available. Please click <b>OK</b> to install.`,
                                type: 'update',
                                hideCancel: false,
                                confirmAction: function(){location.reload();}
                            });
                        }
                    });
                }
            }, 10000); // 10 seconds
        },

        setupContinuousTokenExpirationCheck: function() {
            const self = this;

            // Create a subscription socket messages for page counters. Then update a bind var to get the pager-counter component to register updates(reactivity hack)
            this.pageCounterUnsubscribeFunc = this.$store.subscribe((mutation, state) => {
                if(mutation.type === 'SOCKET_PAGE_COUNTER') {
                    this.pageCounterChanges++;
                }
            }, {prepend: false});

            setInterval(function() {
                if(!localStorage.getItem('access_token') || TELSA.isTokenExpired(localStorage.getItem('access_token'))) {
                    if(self.$route.name !== 'login') {
                        self.logout();
                    }
                }

                // Use this setInterval to also go thru and remove paging counters timestamps that are no longer within in the user defined interval
                let pageCounters = self.$store.state.page_counters;
                let nowUnixMS = TELSA.moment().unix() * 1000;
                for(let username of Object.keys(pageCounters)) {
                    let userPagingReductionSettings = self.$store.state.batchConfig.users.find(u => u.user_username == username).paging_reduction_settings;
                    for(let method of ['email', 'sms', 'whatsapp', 'telegram', 'teams', 'audio', 'client_notification', 'push_notification']) {
                        pageCounters[username][method] = pageCounters[username][method].filter(ts => {
                            return ts > (nowUnixMS - (userPagingReductionSettings[`${method}_interval`]) * 1000);
                        });
                    }
                }
                self.pageCounterChanges++;

            }, 5000); // 5 Seconds
        },

        setupContinuousLockRefresh: function() {
            const self = this;
            setInterval(function() {
                self.$store.dispatch('refreshLock');
            }, 10000) // 10 Seconds
        },

        setupGlobalHttpHandlers: function(self) {
            Vue.http.interceptors.push(function(request) {
                // Modify the outgoing request here

                // Modify response here
                return function(response) {
                    // If the api error was from the ping then don't show error modal because we dont want to spam them with messages. 
                    if(response.url == (TELSA.apiHost + "auth/ping") || response.url == "https://page.telsasoft.com/pingtscloud" || response.url == "https://devpage.telsasoft.com/pingtscloud") {
                        return;
                    }
                    if(!response.ok) {
                        console.log('API ERROR: ', response);
                        TELSA.loading(false);
                        self.showErrorDialog = true;
                        if(response.status == 403 && response.body == "account locked") {
                            self.dialogTitle = 'Account Locked';
                            self.dialogMessage = 'This user account has been locked.'
                        }
                        else if(response.status == 401 && response.body == "access denied") {
                            self.dialogTitle = 'Access Denied';
                            self.dialogMessage = 'The username or password is incorrect.'
                        }
                        else if(response.status == 401 && response.body == "password") {
                            self.dialogTitle = 'Weak Password Detected';
                            self.dialogMessage = `The password set for this account does not meet the password complexity requirements. Please login to 
                                your local desktop-based application (Ops-Alert, Tec-Alert) and change your password there.`;
                        }
                        else {
                            self.dialogTitle = 'Application Error';
                            console.log('response: ', response);
                            self.dialogMessage = response.status ? `${response.status} - ${response.statusText}` : 'Cannot communicate with server.';
                            if(response.bodyText) {
                                self.dialogMessage += `<br><br>${response.bodyText}`;
                            }
                        }
                    }

                    // Get the renewed JWT from response header
                    if(response.headers.map.renew) {
                        if(response.url == (TELSA.apiHost + "locks/release")) {
                            console.log('RELEASING LOCK! DONT RENEW TOKEN!!!!');
                            return;
                        }
                        let jwt = response.headers.map.renew[0];
                        self.setNewAccessToken(jwt);
                    }
                };
            });
        },

        setupPushNotifications: function() {
            const self = this;

            let savePushSubscription = function(pushSubscription) {
                // Set the link between this user and this push subscription object in local storage.
                localStorage.setItem('push_subscription_user_link', JSON.stringify({userId: self.$store.state.user.user_id, endpoint: pushSubscription.endpoint}));
                let route = `${TELSA.apiHost}push/subscription`;
                // saved the link in local storage and now just about to send up the push sub
                return self.$http.post(route, {args: {pushSubscription: pushSubscription}}).then(response => {
                    let result = response.body;
                });
            };

            let createPushSubscription = function() {
                let route = `${TELSA.apiHost}push/key`;
                // Get the VAPID public key
                return self.$http.get(route).then(response => {
                    let vapidPublicKey = response.body;
                    let options = {
                        applicationServerKey: vapidPublicKey, 
                        userVisibleOnly: true, // This is requird for chrome(MDN web)
                    };
                    TELSA.swRegistration.pushManager.subscribe(options).then(pushSubscription => {
                        // Created the Push Sub, lets save it now
                        savePushSubscription(pushSubscription);
                    });
                });
            };

            let createPushSubscriptionPermissionsCheck = function() {
                if(window.Notification.permission == 'granted') {
                    // They have granted browser permissions before. Create push sub now.
                    createPushSubscription();
                }
                else if(window.Notification.permission == 'denied') {
                    // They have already denied the request in the past. 
                    return;
                }
                else {
                    // Ask them for notification permissions
                    self.showPushNotificationPermissionDialog = true;
                    self.pushNotificationPermissionAcceptFunc = function() {
                        return window.Notification.requestPermission().then(permission => {
                            if(permission != 'granted') {
                                // They didnt accept permissions to show notifications! They said no.
                            }
                            else {
                                // They said yes.
                                createPushSubscription();
                            }
                        });
                    };
                }
            }
            

            // Safari is just awful
            if(TELSA.swRegistration && !TELSA.swRegistration.pushManager) {
                // iOS Safari requires that the app has been "added to home screen" for pushManager to work.
                console.log('iOS Safari requires app to be added to homescreen to use pushManager');
                return;
            }

            // Subscription Check
            if(TELSA.swRegistration) {
                TELSA.swRegistration.pushManager.getSubscription().then(pushSubscription => {
                    if(pushSubscription) {
                        // A push sub was found.
                        let pushSubscriptionUserLink = localStorage.getItem('push_subscription_user_link') ? JSON.parse(localStorage.getItem('push_subscription_user_link')) : null;
                        if(!pushSubscriptionUserLink) {
                            console.log('THIS IS BAD! Something or somebody removed our local storage link. We need to create a new push sub now.');
                            createPushSubscriptionPermissionsCheck();
                        }
                        else if(pushSubscriptionUserLink.endpoint != pushSubscription.endpoint) {
                            // THIS IS ALSO BAD! Really no idea how this scenario happens, but need to now create a new push sub.
                            createPushSubscriptionPermissionsCheck();
                        }
                        else if(pushSubscriptionUserLink.userId != self.$store.state.user.user_id) {
                            // The user that this push subscription is linked to is not the current user logged in. Lets re-save it. This will update
                            // the link in local storage and then re-save it on the backend. The resave will take care of the link on the backend. 
                            savePushSubscription(pushSubscription);
                        }
                        else {
                            // Everything is good!
                        }
                    }
                    else {
                        // They dont have a push subscription, so lets create a new one now. create function will also take care of saving it.
                        createPushSubscriptionPermissionsCheck();
                    }
                });
            }
        },

        logout: function() {
            TELSA.loading(true);
            this.$store.commit('setAuthenticatingStatus', false);
            this.$store.commit('setIsDirty', false);
            this.$store.commit('clearStoreData');

            // console.log('dispatch to remove locks');
            // this.$store.dispatch('handleRemoveLocks', null).then(result => {
            //     console.log('handleRemoveLocks promise resolve: ', result);
            // });
            // console.log('IDB remove auth store');
            // TELSA.IDB.remove('serviceWorkerAuthStore', 'access_token').then(result => {
            //     console.log('serviceWorkerAuthStore promise resolve: ', result);
            // });

            let promises = [];
            console.log('promises start');
            promises.push(this.$store.dispatch('handleRemoveLocks', 'ALL'));
            promises.push(TELSA.IDB.remove('serviceWorkerAuthStore', 'access_token'));
            promises.push(caches.delete('dynamic-content-cache')); // This is good because we remove sensitive data from device and handles issue if resources are user specific(user thresholds)
            promises.push(caches.delete('home-page-content')); // There could be sensitive stuff in here, so lets nuke it.
            Promise.all(promises).then(v => {
                console.log('promises done');
                console.log('local storage remove token');
                localStorage.removeItem('access_token');
                Vue.http.headers.common['Authorization'] = null;
                clearInterval(this.pingFunction);
                clearInterval(this.pingCloudFunction);
                clearInterval(this.syncDynamicContentCacheFunction);
                // Disconnect from websocket
                if(this.$socket) {
                    this.$socket.disconnect();
                }
                console.log('set User null');
                this.$store.commit('setUser', null);
                console.log('go to login page');

                // Set a session storage flag that indicates a manual logout. This will be checked immediatley in the login page to know not to start the authenticator process.
                // The login page will then remove this flag so that subsequent refreshes(that still survive the session) will inititate the authenticator process.
                sessionStorage.setItem("logout", 'manual');
                this.$router.push({ name: 'login'});


                // Because this is a Single Page Application, and especially becasue of the renew JWT functionality
                // we NEED to sever all potentially still existing network requests with the server. This will prevent the 
                // server from being able to give us a late API response that contains a renew token.
                console.log('RELOAD()!!');
                location.reload();
            });
            console.log('END SYNCHRONOUS');
        },

        createWebSocketConnection: function(webSocketPort) {
            const screenResolution = `${window.screen.width}x${window.screen.height}`;
            if(process.env.NODE_ENV == 'production') {
                TELSA.webSocketHost = `${window.location.hostname}:${webSocketPort}`;
            }
            else if(process.env.NODE_ENV == 'development') {
                TELSA.webSocketHost = `https://${window.location.hostname}:${webSocketPort}`;
            }
            let store = this.$store;
            Vue.use(new VueSocketIO({
                connection: `${TELSA.webSocketHost}?username=${encodeURIComponent(this.$store.state.user.user_username)}&password=${encodeURIComponent(this.$store.state.user.user_access)}&res=${encodeURIComponent(screenResolution)}`,
                vuex: {
                    store,
                    actionPrefix: 'SOCKET_',
                    mutationPrefix: 'SOCKET_'
                }
            }));
        },

        takeScreenshot: function() {
            let self = this;
            self.takingScreenshot = true;
            html2canvas(document.body).then(function(canvas) {
                let data = canvas.toDataURL('image/png', 1);
                let timestamp = TELSA.moment.tz(self.$store.state.batchConfig.timezone);
                let screenshot = {
                    timestamp: timestamp,
                    displayTime: timestamp.format('MMM DD h:mm A'),
                    area: self.$route.name,
                    name: `${self.$route.name}_${timestamp.format('MMDDYYYY_HHmmss')}.png`,
                    data: data,
                    size: data.length,
                    type: 'image/png'
                }
                self.$store.commit('addScreenshot', screenshot);
                self.takingScreenshot = false;
            });
        }
    },

    created () {
        this.$vuetify.theme.dark = true;

        // Check URL to see if in express mode
        if(this.$store.state.expressMode) {
            return;
        }

        if(this.$workbox) {
            console.log('FOUND WORKBOX IN APP!: ', this.$workbox);
            this.$workbox.addEventListener("waiting", () => {
                this.$workbox.messageSW({type: 'INSTALL_UPDATE'});
            });


            // Global listener for messages from the service worker
            this.$workbox.addEventListener("message", (event) => { 
                console.log("message in app.vue: ", event);

                // Update the user image with the new cached data.
                if(event.data.type == "CACHE_UPDATED" && event.data.payload.cacheName == "user-image-all") {
                    caches.match(event.data.payload.updatedURL).then(resp => {
                        resp.text().then(updatedCachedContent => {
                            let updatedCachedUserImages = JSON.parse(updatedCachedContent);
                            for(let updatedCachedUserImage of updatedCachedUserImages) {
                                for(let user of this.$store.state.batchConfig.users) {
                                    if(updatedCachedUserImage.user_id == user.user_id) {
                                        user.userImage = updatedCachedUserImage.image;
                                        break;
                                    }
                                }
                            }
                        });
                    });
                }
                else if(event.data.type == "NAVIGATE") {
                    this.navigate(event.data.payload.page);
                }

            });
        }

        // Keydown listener for screenshots (Ctrl + Shift + Enter) 
        let self = this;
        document.addEventListener ("keydown", function (zEvent) {
            if(zEvent.ctrlKey && zEvent.shiftKey && zEvent.key === "Enter") {
                self.takeScreenshot();
            }
            else if(zEvent.ctrlKey && zEvent.shiftKey && zEvent.code === "Space") {
                self.drawer = !self.drawer;
            }
            else if(zEvent.ctrlKey && zEvent.shiftKey && zEvent.key === "M") {
                self.$store.commit('setMessagingDrawerOpen', !self.$store.state.messagingDrawerOpen);
            }
            else if(zEvent.ctrlKey && zEvent.shiftKey && zEvent.key === "L") {
                TELSA.loading(false);
            }
        });
    },

    mounted() {
        if(this.$store.state.expressMode) {
            return;
        }

        this.$store.commit('setUser', null);
        let stores = [
            {name: 'audioFileStore', indexes: []},
            {name: 'serviceWorkerAuthStore', indexes: []},
            {name: 'netsuiteStore', indexes: []},
            {name: 'geoMapCoverageDataStore', indexes: [{indexName: 'sectorIdIndex', indexProperty: 'sect_id', unique: false}]},
        ];
        TELSA.IDB.initialize(stores);
        this.checkForJwtInLocalStorage();
        this.setupContinuousTokenExpirationCheck();
        this.setupGlobalHttpHandlers(this);
        this.setupContinuousLockRefresh();

        let self = this;
        // Get the chat message/screenshots popout to hide when user clicks away
        document.getElementById('messaging-drawer-overlay').addEventListener('click', function() {
            self.$store.commit('setMessagingDrawerOpen', false);
        });
        document.getElementById('screenshots-drawer-overlay').addEventListener('click', function() {
            self.$store.commit('setScreenshotsDrawerOpen', false);
        });

        // Manage fullscreen 
        document.onfullscreenchange = (e) => {
            self.$store.commit('setFullscreenElement', document.fullscreenElement);
        };
        document.onwebkitfullscreenchange = (e) => {
            // Safari Fullscreen Change
            self.$store.commit('setFullscreenElement', document.webkitFullscreenElement);
        };

        window.onbeforeunload = (event) => {
            if(!TELSA.downloadFileFlag) {
                this.$store.dispatch('handleRemoveLocks', 'ALL');
            }
        };
    },

    watch: {
        // This triggers for when we the store gets a socket message to kick us off
        kickoff: {
            handler(newVal, oldVal) {
                this.logout();
            },
        },

        audioPlayQueue: {
            handler(newVal, oldVal) {
                this.$store.dispatch('getAudioFileData');
            },
        }
    },


};
</script>

<style scoped>

    @media (max-width: 800px) {
        .username-text {
            display: none;
        }
    }
    .username-row {
        text-align: right;
        margin-right: 1em;
        width: 100%;
        position: relative;
    }

    .username-container {
        width: fit-content;
        float: right;
        cursor: pointer;
    }

    .username-container span {
        font-weight: 500;
    }
    .username-container i {
        box-shadow: 3px 3px 8px 0px rgba(0,0,0,0.3);
        border-radius: 50%;
        font-size: 36px;
    }
    .username-container img {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        vertical-align: middle;
        box-shadow: 3px 3px 8px 0px rgba(0,0,0,0.3);
    }

    @media screen and (max-width: 600px) {
        .username-container span {
            display: none;
        }

        #ts-logo {
            display: none;
        }
        .development {
            display: none !important;
        }
    }

    .alert-icon {
        color: rgba(255, 255, 255, 0.4);
    }
    .alert-icon.active {
        color: #ffffff;
    }

    #ts-logo {
        width: 44.5px;
        height: 36px;
    }

    .product-divider {
        width: calc(100% - 20px); 
        text-align: center; 
        border-bottom: 1px solid #757575; 
        line-height: 0.1em;
        margin: 20px 0 20px 10px;
    }
    .product-divider span {
        background:#424242; 
        padding:0 10px; 
        color: #757575;
    }

    .new-message-count {
        position: absolute;
        right: 5px;
        top: -8px;
    }
    .new-message-count span {
        font-weight: bold;
        font-size: 12px;
        color: yellow;

    }

    .screenshots-count {
        position: absolute;
        right: 3px;
        top: -8px;
    }
    .screenshots-count span {
        font-weight: bold;
        font-size: 12px;
        color: yellow;

    }

    .background-report-running-count {
        position: absolute;
        font-size: 12px;
    }
    .background-report-completed-count {
        position: absolute;
        font-weight: bold;
        font-size: 12px;
        color: yellow;
        right: 3px;
        top: -6px;
    }

    .pulse {
        animation: heartbeat 1s linear infinite both;
    }
    @keyframes heartbeat {
        from {
            transform: scale(1);
            transform-origin: center center;
            animation-timing-function: ease-out;
        }
        10% {
            transform: scale(0.81);
            animation-timing-function: ease-in;
        }
        17% {
            transform: scale(0.98);
            animation-timing-function: ease-out;
        }
        33% {
            transform: scale(0.77);
            animation-timing-function: ease-in;
        }
        45% {
            transform: scale(1);
            animation-timing-function: ease-out;
        }
    }

    .development {
        animation: blinker 1s linear infinite;
    }
    @keyframes blinker {
        50% {
            opacity: 0;
        }
    }

    .host-text {
        color: gray;
        position: absolute;
        bottom: 1em;
        left: 1em;
        font-size: 9pt;
    }

    .warn-blink {
        animation: warnBlink 1s infinite;
    }
    @keyframes warnBlink{
	    0% { color: #ffffff;}
        50% { color: #FB8C00;}
    }

</style>

<style>
    #loading-overlay {
        display: none;
        position: absolute;
        left: 0px;
        top: 0px;
        width:100%;
        height:100%;
        text-align:center;
        z-index: 1000;
        background: rgba(0,0,0,0.3);
    }

    #loading-icon {
        display: inline-block;
        /* position: fixed; */
        position: absolute;
        top: calc(50% - (150px /2));
        left: calc(50% - (150px /2));
    }
    #loading-icon:after {
        content: " ";
        display: block;
        width: 150px;
        height: 150px;
        margin: 1px;
        border-radius: 50%;
        border: 8px solid #fff;
        border-color: #c42111 transparent #c42111 transparent;
        animation: lds-dual-ring 3.2s linear infinite;
        opacity: 1;
        position: relative;
        background-color: transparent;
    }
    @keyframes lds-dual-ring {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }

    #telsasoft-application.thin-scrollbar ::-webkit-scrollbar
    {
        width: 4px !important;
    }

    #telsasoft-application.thin-scrollbar ::-webkit-scrollbar-track
    {
        background: rgba(0, 0, 0, 0.1) !important;
    }

    #telsasoft-application.thin-scrollbar ::-webkit-scrollbar-thumb
    {
        background: rgba(0, 0, 0, 0.5) !important;
    }

    .no-box {
        box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14) !important;
    }

    .no-license-text {
        text-align: center;
        font-size: 16pt;
        font-family: "Roboto", sans-serif !important;
        display: flex;
        justify-content: center;
        align-items: center;
        height: calc(100% - 2em);
    }

    @media screen and (max-width: 600px) {
        .no-license-text {
            font-size: 12pt;
        }
    }

</style>






<style>

    #messaging-drawer {
        width: 1000px !important;
        max-width: '100%' !important;
        box-shadow: 0px 8px 10px -5px rgba(0, 0, 0, 0.2), 0px 16px 24px 2px rgba(0, 0, 0, 0.14), 0px 6px 30px 5px rgba(0, 0, 0, 0.12);
    }
    #messaging-drawer-overlay {
        display: none;
        position: absolute;
        left: 0px;
        top: 0px;
        width:100%;
        height:100%;
        text-align:center;
        z-index: 5;
        opacity: 0.46;
        background-color: rgb(33, 33, 33);
        border-color: rgb(33, 33, 33);
    }

    #screenshots-drawer {
        width: 500px !important;
        max-width: '100%' !important;
        box-shadow: 0px 8px 10px -5px rgba(0, 0, 0, 0.2), 0px 16px 24px 2px rgba(0, 0, 0, 0.14), 0px 6px 30px 5px rgba(0, 0, 0, 0.12);
    }
    #screenshots-drawer-overlay {
        display: none;
        position: absolute;
        left: 0px;
        top: 0px;
        width:100%;
        height:100%;
        text-align:center;
        z-index: 5;
        opacity: 0.46;
        background-color: rgb(33, 33, 33);
        border-color: rgb(33, 33, 33);
    }

    #application-title {
        display: inherit;
    }
    #app-bar-icons {
        display: inherit;
    }
    @media(max-width: 600px) {
        /* #app-bar-icons {
            display: none;
        } */
        #application-title {
            display: none;
        }
    }

    .loading-icon-outer {
        position: relative;
        top: 50%;
        left: 50%;
        margin-left: -55px;
        width: 110px;
        height: 45px;
        background: #c42111;
        border-radius: 3px;
        border: 1px solid #717171;
        z-index: 99998;
        box-shadow: 0 0 5px rgba(0,0,0,.2);
    }

    #loading-icon-container {
        display: table-cell;
        vertical-align: middle;
        padding: 0 9px;
    }

    .loading-icon {
        animation-iteration-count: infinite;
        animation-timing-function: linear;
        -webkit-animation-iteration-count: infinite;
        -webkit-animation-timing-function: linear;
    }

    .loading-icon-inner {
        float: left;
        margin: 0 4px;
        width: 10px;
        height: 10px;
        border-radius: 5px;
        background: #fff;
        -webkit-animation-duration: 1s;
        animation-duration: 1s;
        z-index: 99999;
        animation-name: loading-bg-white-to-blue;
    }

    #loading-icon-inner-1 {
        animation-delay: 0ms;
    }
    #loading-icon-inner-2 {
        animation-delay: 200ms;
    }
    #loading-icon-inner-3 {
        animation-delay: 400ms;
    }
    #loading-icon-inner-4 {
        animation-delay: 600ms;
    }
    #loading-icon-inner-5 {
        animation-delay: 800ms;
    }

    @keyframes loading-bg-white-to-blue {
        0% {
            background: #fff;
            transform: translate3d(0,0,0);
        }
        40% {
            background: #fff;
            transform: translate3d(0,0,0);
        }
        41% {
            background: #424242;
            transform: translate3d(0,0,0);
        }
        60% {
            background: #424242;
            transform: translate3d(0,0,0);
        }
        61% {
            background: #fff;
            transform: translate3d(0,0,0);
        }
        100% {
            background: #fff;
            transform: translate3d(0,0,0);
        }
    }

    .about-info-container {
        background: radial-gradient(#B01D0F 15%, transparent 16%) 0 0,
        radial-gradient(#B01D0F 15%, transparent 16%) 4px 4px,
        radial-gradient(rgba(196,33,17,.8) 15%, transparent 20%) 0 1px,
        radial-gradient(rgba(196,33,17,.8) 15%, transparent 20%) 8px 9px;
        background-color:#c42111;
        background-size:8px 8px;
        
        color: #ffffff;
        text-align: center;
        position: absolute;
        bottom: 0px;
        width: 100%;
        height: 30px;
        font-weight: bold;
        cursor: pointer;
    }
    .about-info-container:hover {
        background-color: rgba(201,55,40, 1.0);
    }

    .about-info-container span {
        display: block;
        margin-top: 4px;
    }

    .is-dirty-save-button-icon {
        position: absolute !important;
        color: yellow !important;
        z-index: 10;
        font-size: 18px;
        right: -22px;
        top: -18px;
    }

    #telsasoft-application .theme--dark.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
        background-color: transparent;
    }

    .v-textarea textarea {
        line-height: 20px;
    }

    .theme--dark.v-data-table tbody tr:not(:last-child) td:not(.v-data-table__mobile-row) {
        border-bottom: 1px solid rgba(255, 255, 255, 0.12);
    }
    .theme--dark.v-data-table tbody tr:hover:not(.v-data-table__expanded__content) {
        background: #616161;
    }

    .v-data-table--dense td {
        height: 24px !important;
    }
    .v-data-table td {
        font-size: 14px;
        height: 48px;
    }

    .v-data-table td, .v-data-table th {
        padding: 0 16px;
    }

    /* Style fix for vuetify disabled checkbox */
    .v-input--selection-controls__input input[role=checkbox], .v-input--selection-controls__input input[role=radio], .v-input--selection-controls__input input[role=switch] {
        opacity: 0 !important;
    }

</style>
